<script>
import { GlIcon, GlLink, GlDisclosureDropdown, GlDisclosureDropdownItem } from '@gitlab/ui';
import queryString from 'query-string';
import LANGUAGE_SWITCH_IMG from '~/images/switch.png';
import { languageCode } from '~/javascripts/lib/locale';

export default {
  name: 'SwitchLanguage',
  components: {
    GlIcon,
    GlLink,
    GlDisclosureDropdown,
    GlDisclosureDropdownItem,
  },
  computed: {
    showSwitchLanguage() {
      return gon.global.jh;
    },
    currentLanguage() {
      return this.languageCode();
    },
  },
  methods: {
    languageCode,
    languageSwitchUrl(language = 'en') {
      const originSearchKeys = queryString.parse(window.location.search);
      const searchKeyToString = queryString.stringify({ ...originSearchKeys, locale: language });
      return `${window.location.pathname}?${searchKeyToString}`;
    },
  },
  LANGUAGE_SWITCH_IMG,
};
</script>

<template>
  <gl-disclosure-dropdown
    v-if="showSwitchLanguage"
    toggle-class="gl-font-sm font-weight-bold d-flex align-items-center"
    placement="bottom-end"
    class="jh-switch-language"
  >
    <template #toggle>
      <span id="jh-i18n-btn" class="mr-1">
        <img
          :src="$options.LANGUAGE_SWITCH_IMG"
          alt="Switch language"
          style="width: 18px; vertical-align: middle"
        />
      </span>
      <gl-icon :size="12" name="chevron-lg-down" />
    </template>
    <gl-disclosure-dropdown-item :class="{ 'gl-bg-gray-50': currentLanguage === 'zh-CN' }">
      <gl-link :href="languageSwitchUrl('zh-CN')">简体中文</gl-link>
    </gl-disclosure-dropdown-item>
    <gl-disclosure-dropdown-item
      :class="{ 'gl-bg-gray-50': currentLanguage === 'en' }"
      :href="languageSwitchUrl('en')"
    >
      <gl-link :href="languageSwitchUrl('en')">English</gl-link>
    </gl-disclosure-dropdown-item>
  </gl-disclosure-dropdown>
</template>
